import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2PortfoliosEdit } from "./edit";
import { K2PortfoliosNew } from "./new";
import { K2PortfoliosTable } from "./table";
export default function K2Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2PortfoliosEdit />} />
      <Route index element={<K2PortfoliosTable />} />
      <Route path="/new" element={<K2PortfoliosNew />} />
    </Routes>
  );
}
